const toFormRow = (f) => ({
  id: f.id,
  name: f.name ?? '',
  active: Boolean(f.active),
  submissionCount: typeof f.submissionCount === 'number' ? f.submissionCount : 0,
  personKey: f.personKey,
  createdBy: f.createdBy ?? null,
  schema: f.schema,
});

/** Shape API `/api/content/form` rows for the Forms DataGrid. */
export const mapApiRowsToForms = (rows) => {
  if (!Array.isArray(rows)) {
    return [];
  }
  return rows.map(toFormRow);
};

/** Map GET `/api/content/form/:id` JSON for row actions / previews (same shape as list rows). */
export const mapApiFormDefinitionToForm = (f) => {
  if (f == null) {
    return null;
  }
  return toFormRow(f);
};

const toFormsCsvRow = (form) => [
  form.name ?? '',
  form.active ? 'Yes' : 'No',
  typeof form.submissionCount === 'number' ? String(form.submissionCount) : '0',
];

export const FORMS_CSV_HEADERS = Object.freeze(['Name', 'Active', 'Submission count']);

export const FORMS_CSV_FILENAME = 'forms.csv';

/**
 * Build a CSV export payload (`filename`, `headers`, `rows`) for the Forms grid.
 * @param {readonly { name?: string, active?: boolean, submissionCount?: number }[]} forms
 */
export const buildFormsCsvExportPayload = (forms) => ({
  filename: FORMS_CSV_FILENAME,
  headers: [...FORMS_CSV_HEADERS],
  rows: forms.map(toFormsCsvRow),
});
